import { useEffect } from "react";

interface UseInfiniteScrollParams {
  listContainerRef: React.RefObject<HTMLElement>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  offset?: number; // Offset in pixels before reaching the bottom
}

export const useInfiniteScroll = ({
  listContainerRef,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  offset = 20,
}: UseInfiniteScrollParams) => {
  useEffect(() => {
    const handleScroll = () => {
      if (listContainerRef.current) {
        const container = listContainerRef.current;
        const scrollPosition = container.scrollHeight - container.scrollTop;
        const offsetTriggerPoint = container.clientHeight + offset;

        if (
          scrollPosition <= offsetTriggerPoint &&
          hasNextPage &&
          !isFetchingNextPage
        ) {
          fetchNextPage();
        }
      }
    };

    const container = listContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    listContainerRef,
    offset,
  ]);
};
